import script from "./alarmLog.vue?vue&type=script&setup=true&lang=js"
export * from "./alarmLog.vue?vue&type=script&setup=true&lang=js"

import "./alarmLog.vue?vue&type=style&index=0&id=fdc7c196&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/campus-heating-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fdc7c196"]])

export default __exports__